export type LegalBlock = { t: "h" | "p" | "li"; x: string };
export const legalPages: Record<"privacy-policy" | "terms-and-conditions", LegalBlock[]> = {
  "privacy-policy": [
    {
      t: "h",
      x: "Who we are",
    },
    {
      t: "p",
      x: "Our website address is: https://leadershipedge.live.",
    },
    {
      t: "h",
      x: "What personal data we collect and why we collect it",
    },
    {
      t: "h",
      x: "Comments",
    },
    {
      t: "p",
      x: "When visitors leave comments on the site we collect the data shown in the comments form, and also the visitor’s IP address and browser user agent string to help spam detection.",
    },
    {
      t: "p",
      x: "Media",
    },
    {
      t: "p",
      x: "If you upload images to the website, you should avoid uploading images with embedded location data (EXIF GPS) included. Visitors to the website can download and extract any location data from images on the website.",
    },
    {
      t: "h",
      x: "Contact forms",
    },
    {
      t: "h",
      x: "Cookies",
    },
    {
      t: "p",
      x: "If you leave a comment on our site you may opt-in to saving your name, email address and website in cookies. These are for your convenience so that you do not have to fill in your details again when you leave another comment. These cookies will last for one year.",
    },
    {
      t: "p",
      x: "If you visit our login page, we will set a temporary cookie to determine if your browser accepts cookies. This cookie contains no personal data and is discarded when you close your browser.",
    },
    {
      t: "p",
      x: "When you log in, we will also set up several cookies to save your login information and your screen display choices. Login cookies last for two days, and screen options cookies last for a year. If you select “Remember Me”, your login will persist for two weeks. If you log out of your account, the login cookies will be removed.",
    },
    {
      t: "p",
      x: "If you edit or publish an article, an additional cookie will be saved in your browser. This cookie includes no personal data and simply indicates the post ID of the article you just edited. It expires after 1 day.",
    },
    {
      t: "h",
      x: "Embedded content from other websites",
    },
    {
      t: "p",
      x: "Articles on this site may include embedded content (e.g. videos, images, articles, etc.). Embedded content from other websites behaves in the exact same way as if the visitor has visited the other website.",
    },
    {
      t: "p",
      x: "These websites may collect data about you, use cookies, embed additional third-party tracking, and monitor your interaction with that embedded content, including tracking your interaction with the embedded content if you have an account and are logged in to that website.",
    },
    {
      t: "h",
      x: "Analytics",
    },
    {
      t: "h",
      x: "Who we share your data with",
    },
    {
      t: "h",
      x: "How long we retain your data",
    },
    {
      t: "p",
      x: "If you leave a comment, the comment and its metadata are retained indefinitely. This is so we can recognize and approve any follow-up comments automatically instead of holding them in a moderation queue.",
    },
    {
      t: "p",
      x: "For users that register on our website (if any), we also store the personal information they provide in their user profile. All users can see, edit, or delete their personal information at any time (except they cannot change their username). Website administrators can also see and edit that information.",
    },
    {
      t: "h",
      x: "What rights you have over your data",
    },
    {
      t: "p",
      x: "If you have an account on this site, or have left comments, you can request to receive an exported file of the personal data we hold about you, including any data you have provided to us. You can also request that we erase any personal data we hold about you. This does not include any data we are obliged to keep for administrative, legal, or security purposes.",
    },
    {
      t: "h",
      x: "Where we send your data",
    },
    {
      t: "p",
      x: "Visitor comments may be checked through an automated spam detection service.",
    },
  ],
  "terms-and-conditions": [
    {
      t: "p",
      x: "Last updated: November 12, 2020 Please read these terms and conditions carefully before using Our Service",
    },
    {
      t: "h",
      x: "Interpretation and Definitions",
    },
    {
      t: "h",
      x: "Interpretation",
    },
    {
      t: "p",
      x: "The words of which the initial letter is capitalized have meanings defined under the following conditions. The following definitions shall have the same meaning regardless of whether they appear in singular or in plural.",
    },
    {
      t: "h",
      x: "Definitions",
    },
    {
      t: "p",
      x: "For the purposes of these Terms and Conditions:",
    },
    {
      t: "li",
      x: "Affiliate means an entity that controls, is controlled by or is under common control with a party, where “control” means ownership of 50% or more of the shares, equity interest or other securities entitled to vote for election of directors or other managing authority.",
    },
    {
      t: "li",
      x: "Account means a unique account created for You to access our Service or parts of our Service.",
    },
    {
      t: "li",
      x: "Country refers to: Arizona, United States",
    },
    {
      t: "li",
      x: "Company (referred to as either “the Company”, “We”, “Us” or “Our” in this Agreement) refers to Looking Forward Consulting, LLC, 15324 W Roma Ave, Goodyear, AZ 85395.",
    },
    {
      t: "li",
      x: "Content refers to content such as text, images, or other information that can be posted, uploaded, linked to or otherwise made available by You, regardless of the form of that content.",
    },
    {
      t: "li",
      x: "Device means any device that can access the Service such as a computer, a cellphone or a digital tablet.",
    },
    {
      t: "li",
      x: "Feedback means feedback, innovations or suggestions sent by You regarding the attributes, performance or features of our Service.",
    },
    {
      t: "li",
      x: "Promotions refer to contests, sweepstakes or other promotions offered through the Service.",
    },
    {
      t: "li",
      x: "Service refers to the Website.",
    },
    {
      t: "li",
      x: "Subscriptions refer to the services or access to the Service offered on a subscription basis by the Company to You.",
    },
    {
      t: "li",
      x: "Terms and Conditions (also referred as “Terms”) mean these Terms and Conditions that form the entire agreement between You and the Company regarding the use of the Service.",
    },
    {
      t: "li",
      x: "Third-party Social Media Service means any services or content (including data, information, products or services) provided by a third-party that may be displayed, included or made available by the Service.",
    },
    {
      t: "li",
      x: "Website refers to Leadership Edge Live, accessible from www.leadershipedge.live",
    },
    {
      t: "li",
      x: "You means the individual accessing or using the Service, or the company, or other legal entity on behalf of which such individual is accessing or using the Service, as applicable.",
    },
    {
      t: "h",
      x: "Acknowledgment",
    },
    {
      t: "p",
      x: "These are the Terms and Conditions governing the use of this Service and the agreement that operates between You and the Company. These Terms and Conditions set out the rights and obligations of all users regarding the use of the Service.",
    },
    {
      t: "p",
      x: "Your access to and use of the Service is conditioned on Your acceptance of and compliance with these Terms and Conditions. These Terms and Conditions apply to all visitors, users and others who access or use the Service. By accessing or using the Service You agree to be bound by these Terms and Conditions. If You disagree with any part of these Terms and Conditions then You may not access the Service.",
    },
    {
      t: "p",
      x: "You represent that you are over the age of 18. The Company does not permit those under 18 to use the Service. Your access to and use of the Service is also conditioned on Your acceptance of and compliance with the Privacy Policy of the Company. Our Privacy Policy describes Our policies and procedures on the collection, use and disclosure of Your personal information when You use the Application or the Website and tells You about Your privacy rights and how the law protects You. Please read Our Privacy Policy carefully before using Our Service.",
    },
    {
      t: "h",
      x: "Subscriptions",
    },
    {
      t: "h",
      x: "Subscription period",
    },
    {
      t: "p",
      x: "The Service or some parts of the Service are available only with a paid Subscription. You will be billed in advance on a recurring and periodic basis (such as daily, weekly, monthly or annually), depending on the type of Subscription plan you select when purchasing the Subscription.",
    },
    {
      t: "p",
      x: "At the end of each period, Your Subscription will automatically renew under the exact same conditions unless You cancel it or the Company cancels it.",
    },
    {
      t: "h",
      x: "Subscription cancellations",
    },
    {
      t: "p",
      x: "You may cancel Your Subscription renewal either through Your Account settings page or by contacting the Company. You will not receive a refund for the fees You already paid for Your current Subscription period and You will be able to access the Service until the end of Your current Subscription period.",
    },
    {
      t: "h",
      x: "Billing",
    },
    {
      t: "p",
      x: "You shall provide the Company with accurate and complete billing information including full name, address, state, zip code, telephone number, and a valid payment method information.",
    },
    {
      t: "p",
      x: "Should automatic billing fail to occur for any reason, the Company will issue an electronic invoice indicating that you must proceed manually, within a certain deadline date, with the full payment corresponding to the billing period as indicated on the invoice.",
    },
    {
      t: "h",
      x: "Fee Changes",
    },
    {
      t: "p",
      x: "The Company, in its sole discretion and at any time, may modify the Subscription fees. Any Subscription fee change will become effective at the end of the then-current Subscription period.",
    },
    {
      t: "p",
      x: "The Company will provide You with reasonable prior notice of any change in Subscription fees to give You an opportunity to terminate Your Subscription before such change becomes effective.",
    },
    {
      t: "p",
      x: "Your continued use of the Service after the Subscription fee change comes into effect constitutes Your agreement to pay the modified Subscription fee amount.",
    },
    {
      t: "h",
      x: "Refunds",
    },
    {
      t: "p",
      x: "Except when required by law, paid Subscription fees are non-refundable.",
    },
    {
      t: "p",
      x: "Certain refund requests for Subscriptions may be considered by the Company on a case-by-case basis and granted at the sole discretion of the Company.",
    },
    {
      t: "h",
      x: "Promotions",
    },
    {
      t: "p",
      x: "Any Promotions made available through the Service may be governed by rules that are separate from these Terms.",
    },
    {
      t: "p",
      x: "If You participate in any Promotions, please review the applicable rules as well as our Privacy policy. If the rules for a Promotion conflict with these Terms, the Promotion rules will apply.",
    },
    {
      t: "h",
      x: "User Accounts",
    },
    {
      t: "p",
      x: "When You create an account with Us, You must provide Us information that is accurate, complete, and current at all times. Failure to do so constitutes a breach of the Terms, which may result in immediate termination of Your account on Our Service.",
    },
    {
      t: "p",
      x: "You are responsible for safeguarding the password that You use to access the Service and for any activities or actions under Your password, whether Your password is with Our Service or a Third-Party Social Media Service.",
    },
    {
      t: "p",
      x: "You agree not to disclose Your password to any third party. You must notify Us immediately upon becoming aware of any breach of security or unauthorized use of Your account.",
    },
    {
      t: "p",
      x: "You may not use as a username the name of another person or entity or one that is not lawfully available for use, a name or trademark that is subject to any rights of another person or entity other than You without appropriate authorization, or a name that is otherwise offensive, vulgar or obscene.",
    },
    {
      t: "h",
      x: "Content",
    },
    {
      t: "h",
      x: "Your Right to Post Content",
    },
    {
      t: "p",
      x: "Our Service allows You to post Content. You are responsible for the Content that You post to the Service, including its legality, reliability, and appropriateness.",
    },
    {
      t: "p",
      x: "By posting Content to the Service, You grant Us the right and license to use, modify, publicly perform, publicly display, reproduce, and distribute such Content on and through the Service. You retain any and all of Your rights to any Content You submit, post or display on or through the Service and You are responsible for protecting those rights. You agree that this license includes the right for Us to make Your Content available to other users of the Service, who may also use Your Content subject to these Terms.",
    },
    {
      t: "p",
      x: "You represent and warrant that: (i) the Content is Yours (You own it) or You have the right to use it and grant Us the rights and license as provided in these Terms, and (ii) the posting of Your Content on or through the Service does not violate the privacy rights, publicity rights, copyrights, contract rights or any other rights of any person.",
    },
    {
      t: "h",
      x: "Content Restrictions",
    },
    {
      t: "p",
      x: "The Company is not responsible for the content of the Service’s users. You expressly understand and agree that You are solely responsible for the Content and for all activity that occurs under your account, whether done so by You or any third person using Your account.",
    },
    {
      t: "p",
      x: "You may not transmit any Content that is unlawful, offensive, upsetting, intended to disgust, threatening, libelous, defamatory, obscene or otherwise objectionable. Examples of such objectionable Content include, but are not limited to, the following:",
    },
    {
      t: "li",
      x: "Unlawful or promoting unlawful activity.",
    },
    {
      t: "li",
      x: "Defamatory, discriminatory, or mean-spirited content, including references or",
    },
    {
      t: "li",
      x: "commentary about religion, race, sexual orientation, gender, national/ethnic origin, or",
    },
    {
      t: "li",
      x: "other targeted groups.",
    },
    {
      t: "li",
      x: "Spam, machine – or randomly – generated, constituting unauthorized or unsolicited",
    },
    {
      t: "li",
      x: "advertising, chain letters, any other form of unauthorized solicitation, or any form of",
    },
    {
      t: "li",
      x: "lottery or gambling.",
    },
    {
      t: "li",
      x: "Containing or installing any viruses, worms, malware, trojan horses, or other content that is designed or intended to disrupt, damage, or limit the functioning of any software, hardware or telecommunications equipment or to damage or obtain unauthorized access to any data or other information of a third person.",
    },
    {
      t: "li",
      x: "Infringing on any proprietary rights of any party, including patent, trademark, trade secret, copyright, right of publicity or other rights.",
    },
    {
      t: "li",
      x: "Impersonating any person or entity including the Company and its employees or representatives.",
    },
    {
      t: "li",
      x: "Violating the privacy of any third person.",
    },
    {
      t: "li",
      x: "False information and features.",
    },
    {
      t: "p",
      x: "The Company reserves the right, but not the obligation, to, in its sole discretion, determine whether or not any Content is appropriate and complies with this Terms, refuse or remove this Content. The Company further reserves the right to make formatting and edits and change the manner any Content. The Company can also limit or revoke the use of the Service if You post such objectionable Content. As the Company cannot control all content posted by users and/or third parties on the Service, you agree to use the Service at your own risk. You understand that by using the Service You may be exposed to content that You may find offensive, indecent, incorrect or objectionable, and You agree that under no circumstances will the Company be liable in any way for any content, including any errors or omissions in any content, or any loss or damage of any kind incurred as a result of your use of any content.",
    },
    {
      t: "h",
      x: "Content Backups",
    },
    {
      t: "p",
      x: "Although regular backups of Content are performed, the Company does not guarantee there will be no loss or corruption of data.",
    },
    {
      t: "p",
      x: "Corrupt or invalid backup points may be caused by, without limitation, Content that is corrupted prior to being backed up or that changes during the time a backup is performed.",
    },
    {
      t: "p",
      x: "The Company will provide support and attempt to troubleshoot any known or discovered issues that may affect the backups of Content. But You acknowledge that the Company has no liability related to the integrity of Content or the failure to successfully restore Content to a usable state.",
    },
    {
      t: "p",
      x: "You agree to maintain a complete and accurate copy of any Content in a location independent of the Service.",
    },
    {
      t: "h",
      x: "Copyright Policy",
    },
    {
      t: "h",
      x: "Intellectual Property Infringement",
    },
    {
      t: "p",
      x: "We respect the intellectual property rights of others. It is Our policy to respond to any claim that Content posted on the Service infringes a copyright or other intellectual property infringement of any person.",
    },
    {
      t: "p",
      x: "If You are a copyright owner, or authorized on behalf of one, and You believe that the copyrighted work has been copied in a way that constitutes copyright infringement that is taking place through the Service, You must submit Your notice in writing to the attention of our copyright agent via email at support@leadershipedge.live and include in Your notice a detailed description of the alleged infringement.",
    },
    {
      t: "p",
      x: "You may be held accountable for damages (including costs and attorneys’ fees) for misrepresenting that any Content is infringing Your copyright.",
    },
    {
      t: "h",
      x: "DMCA Notice and DMCA Procedure for Copyright Infringement Claims",
    },
    {
      t: "p",
      x: "You may submit a notification pursuant to the Digital Millennium Copyright Act (DMCA) by providing our copyright agent with the following information in writing (see 17 U.S.C 512(c)(3) for further detail):",
    },
    {
      t: "li",
      x: "An electronic or physical signature of the person authorized to act on behalf of the owner of the copyright’s interest.",
    },
    {
      t: "li",
      x: "A description of the copyrighted work that You claim has been infringed, including the URL (i.e., web page address) of the location where the copyrighted work exists or a copy of the copyrighted work.",
    },
    {
      t: "li",
      x: "Identification of the URL or other specific location on the Service where the material that You claim is infringing is located.",
    },
    {
      t: "li",
      x: "Your address, telephone number, and email address.",
    },
    {
      t: "li",
      x: "A statement by You that You have a good faith belief that the disputed use is not authorized by the copyright owner, its agent, or the law.",
    },
    {
      t: "li",
      x: "A statement by You, made under penalty of perjury, that the above information in Your notice is accurate and that You are the copyright owner or authorized to act on the copyright owner’s behalf.",
    },
    {
      t: "p",
      x: "You can contact our copyright agent via email at support@leadershipedge.live. Upon receipt of a notification, the Company will take whatever action, in its sole discretion, it deems appropriate, including removal of the challenged content from the Service.",
    },
    {
      t: "h",
      x: "Intellectual Property",
    },
    {
      t: "p",
      x: "The Service and its original content (excluding Content provided by You or other users), features and functionality are and will remain the exclusive property of the Company and its licensors.",
    },
    {
      t: "p",
      x: "The Service is protected by copyright, trademark, and other laws of both the Country and foreign countries.",
    },
    {
      t: "p",
      x: "Our trademarks and trade dress may not be used in connection with any product or service without the prior written consent of the Company.",
    },
    {
      t: "h",
      x: "Your Feedback to Us",
    },
    {
      t: "p",
      x: "You assign all rights, title and interest in any Feedback You provide the Company. If for any reason such assignment is ineffective, You agree to grant the Company a non-exclusive, perpetual, irrevocable, royalty free, worldwide right and license to use, reproduce, disclose, sub-license, distribute, modify and exploit such Feedback without restriction.",
    },
    {
      t: "h",
      x: "Links to Other Websites",
    },
    {
      t: "p",
      x: "Our Service may contain links to third-party web sites or services that are not owned or controlled by the Company.",
    },
    {
      t: "p",
      x: "The Company has no control over, and assumes no responsibility for, the content, privacy policies, or practices of any third-party web sites or services. You further acknowledge and agree that the Company shall not be responsible or liable, directly or indirectly, for any damage or loss caused or alleged to be caused by or in connection with the use of or reliance on any such content, goods or services available on or through any such web sites or services.",
    },
    {
      t: "p",
      x: "We strongly advise You to read the terms and conditions and privacy policies of any third- party web sites or services that You visit.",
    },
    {
      t: "h",
      x: "Termination",
    },
    {
      t: "p",
      x: "We may terminate or suspend Your Account immediately, without prior notice or liability, for any reason whatsoever, including without limitation if You breach these Terms and Conditions.",
    },
    {
      t: "p",
      x: "Upon termination, Your right to use the Service will cease immediately. If You wish to terminate Your Account, You may simply discontinue using the Service.",
    },
    {
      t: "h",
      x: "Limitation of Liability",
    },
    {
      t: "p",
      x: "Notwithstanding any damages that You might incur, the entire liability of the Company and any of its suppliers under any provision of this Terms and Your exclusive remedy for all of the foregoing shall be limited to the amount actually paid by You through the Service or 100 USD if You haven’t purchased anything through the Service.",
    },
    {
      t: "p",
      x: "To the maximum extent permitted by applicable law, in no event shall the Company or its suppliers be liable for any special, incidental, indirect, or consequential damages whatsoever (including, but not limited to, damages for loss of profits, loss of data or other information, for business interruption, for personal injury, loss of privacy arising out of or in any way related to the use of or inability to use the Service, third-party software and/or third-party hardware used with the Service, or otherwise in connection with any provision of this Terms), even if the Company or any supplier has been advised of the possibility of such damages and even if the remedy fails of its essential purpose.",
    },
    {
      t: "p",
      x: "Some states do not allow the exclusion of implied warranties or limitation of liability for incidental or consequential damages, which means that some of the above limitations may not apply. In these states, each party’s liability will be limited to the greatest extent permitted by law.",
    },
    {
      t: "h",
      x: "“AS IS” and “AS AVAILABLE” Disclaimer",
    },
    {
      t: "p",
      x: "The Service is provided to You “AS IS” and “AS AVAILABLE” and with all faults and defects without warranty of any kind. To the maximum extent permitted under applicable law, the Company, on its own behalf and on behalf of its Affiliates and its and their respective licensors and service providers, expressly disclaims all warranties, whether express, implied, statutory or otherwise, with respect to the Service, including all implied warranties of merchantability, fitness for a particular purpose, title and non-infringement, and warranties that may arise out of course of dealing, course of performance, usage or trade practice. Without limitation to the foregoing, the Company provides no warranty or undertaking, and makes no representation of any kind that the Service will meet Your requirements, achieve any intended results, be compatible or work with any other software, applications, systems or services, operate without interruption, meet any performance or reliability standards or be error free or that any errors or defects can or will be corrected.",
    },
    {
      t: "p",
      x: "Without limiting the foregoing, neither the Company nor any of the Company’s providers make any representation or warranty of any kind, express or implied: (i) as to the operation or availability of the Service, or the information, content, and materials or products included thereon; (ii) that the Service will be uninterrupted or error free; (iii) as to the accuracy, reliability, or currency of any information or content provided through the Service; or (iv) that the Service, its servers, the content, or emails sent from or on behalf of the Company are free of viruses, scripts, trojan horses, worms, malware, timebombs or other harmful components.",
    },
    {
      t: "p",
      x: "Some jurisdictions do not allow the exclusion of certain types of warranties or limitations on applicable statutory rights of a consumer, so some or all of the above exclusions and limitations may not apply to You. But in such a case the exclusions and limitations set forth in this section shall be applied to the greatest extent enforceable under applicable law.",
    },
    {
      t: "h",
      x: "Governing Law",
    },
    {
      t: "p",
      x: "The laws of the Country, excluding its conflicts of law rules, shall govern this Terms and Your use of the Service. Your use of the Application may also be subject to other local, state, national, or international laws.",
    },
    {
      t: "h",
      x: "Disputes Resolution",
    },
    {
      t: "p",
      x: "If You have any concern or dispute about the Service, You agree to first try to resolve the dispute informally by contacting the Company.",
    },
    {
      t: "h",
      x: "For European Union (EU) Users",
    },
    {
      t: "p",
      x: "If You are a European Union consumer, you will benefit from any mandatory provisions of the law of the country in which you are resident in.",
    },
    {
      t: "h",
      x: "United States Federal Government End Use Provisions",
    },
    {
      t: "p",
      x: "If You are a U.S. federal government end user, our Service is a “Commercial Item” as that term is defined at 48 C.F.R. §2.101.",
    },
    {
      t: "h",
      x: "United States Legal Compliance",
    },
    {
      t: "p",
      x: "You represent and warrant that (i) You are not located in a country that is subject to the United States government embargo, or that has been designated by the United States government as a “terrorist supporting” country, and (ii) You are not listed on any United States government list of prohibited or restricted parties.",
    },
    {
      t: "h",
      x: "Severability and Waiver",
    },
    {
      t: "h",
      x: "Severability",
    },
    {
      t: "p",
      x: "If any provision of these Terms is held to be unenforceable or invalid, such provision will be changed and interpreted to accomplish the objectives of such provision to the greatest extent possible under applicable law and the remaining provisions will continue in full force and effect.",
    },
    {
      t: "h",
      x: "Waiver",
    },
    {
      t: "p",
      x: "Except as provided herein, the failure to exercise a right or to require performance of an obligation under this Terms shall not affect a party’s ability to exercise such right or require such performance at any time thereafter nor shall be the waiver of a breach constitute a waiver of any subsequent breach.",
    },
    {
      t: "h",
      x: "Translation Interpretation",
    },
    {
      t: "p",
      x: "These Terms and Conditions may have been translated if We have made them available to You on our Service. You agree that the original English text shall prevail in the case of a dispute.",
    },
    {
      t: "h",
      x: "Changes to These Terms and Conditions",
    },
    {
      t: "p",
      x: "We reserve the right, at Our sole discretion, to modify or replace these Terms at any time. If a revision is material We will make reasonable efforts to provide at least 30 days’ notice prior to any new terms taking effect. What constitutes a material change will be determined at Our sole discretion.",
    },
    {
      t: "p",
      x: "By continuing to access or use Our Service after those revisions become effective, You agree to be bound by the revised terms. If You do not agree to the new terms, in whole or in part, please stop using the website and the Service.",
    },
    {
      t: "h",
      x: "Contact Us",
    },
    {
      t: "p",
      x: "If you have any questions about these Terms and Conditions, You can contact us:",
    },
    {
      t: "p",
      x: "• By email: support@leadershipedge.live",
    },
  ],
};
